import { render, staticRenderFns } from "./DropDownSimple.vue?vue&type=template&id=8d75b2f6&scoped=true&"
import script from "./DropDownSimple.vue?vue&type=script&lang=ts&"
export * from "./DropDownSimple.vue?vue&type=script&lang=ts&"
import style0 from "./DropDownSimple.vue?vue&type=style&index=0&id=8d75b2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d75b2f6",
  null
  
)

export default component.exports